import { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import api from '../../../../services/api';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Loading from '../../../../load/loading';
import HeaderSession from '../../../../utils/headerSession';
import { Card, Paper, Typography } from '@mui/material';
import RegisterAccess from '../../../../utils/registerAccess';
import { makeStyles } from '@material-ui/core';
import ListaVazia from '../../../../utils/listaVazia';
import Date from '../../../../utils/date';
import FerramentaNavegacaoExportacao from '../../../../utils/paginacao';
import TempoPassado from '../../../../utils/tempoPassado';


const useStyles = makeStyles((theme) => ({
  hover: { '&:hover': { backgroundColor: '#85287d8a' }, cursor: 'pointer' },
}))

const ListaSolicitacoesImportacao = () => {
  const classes = useStyles();
  const { id, area , status} = useParams()
  const [solicitacoes, setSolicitacoes] = useState('');
  const [configLista, setConfigLista] = useState('');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState(searchParams.get("page"));

  useEffect(() => {
    setSolicitacoes('');
    api.get(`/solicitacao-importacaos?status=${status}&page=${page}&importador=${id ?? ''}&solicitacaoArea=${area}`)
      .then(response => {
        setSolicitacoes(response.data.solicitacaoImportacaos)
        setConfigLista(response.data)
      }).catch(err => {
        // console.log(err)
      })
  }, [status, id, page])

  return (

    <>
      <RegisterAccess page={'lista de solicitações de importação'} />
      {!id && <HeaderSession title={'SOLICITAÇÕES DE IMPORTAÇÃO PARA PRODUTOS | ' + area} />}

      {solicitacoes ? solicitacoes.length > 0 ?

        <Card sx={{ width: '100%', overflow: 'hidden' }} >
          <TableContainer sx={{ border: "1px black" }} component={Paper}>
            <Table sx={{ border: "1px", borderColor: "black" }}>
              <TableHead sx={{ backgroundColor: "#dcdede" }}>
                <TableRow>
                  <TableCell align="center" ><Typography noWrap> <strong> Importador </strong></Typography></TableCell>
                  <TableCell align="center" ><Typography noWrap> <strong> Fornecedor </strong></Typography></TableCell>
                  <TableCell align="center" ><Typography noWrap> <strong> Solicitação </strong></Typography></TableCell>
                  {/* <TableCell align="center" ><Typography noWrap> <strong> Tipo de Certificado </strong></Typography></TableCell> */}
                  <TableCell align="center" ><Typography noWrap> <strong> Fatura Proforma Nº </strong></Typography></TableCell>
                  <TableCell align="center" ><Typography noWrap> <strong> Pais de Origem </strong></Typography></TableCell>
                  <TableCell align="center" ><Typography noWrap> <strong> Estado </strong></Typography></TableCell>
                  <TableCell align="center" ><Typography noWrap> <strong> Data </strong></Typography></TableCell>
                  <TableCell ><Typography noWrap> <strong>Ultima intervenção</strong></Typography></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {solicitacoes.map((solicitacao) => (
                  <TableRow key={solicitacao._id} className={classes.hover} onClick={() => { navigate(`/admin/dmts/gest/solicitacao-de-importacao/${solicitacao._id}`) }}>

                    <TableCell ><Typography noWrap> {solicitacao.importador?.nome}</Typography></TableCell>
                    <TableCell ><Typography noWrap> {solicitacao?.fornecedorNome}</Typography></TableCell>
                    <TableCell ><Typography noWrap> {solicitacao.numero}</Typography></TableCell>
                    {/* <TableCell  ><Typography > {solicitacao.tipoCertificado}</Typography></TableCell> */}
                    <TableCell  ><Typography noWrap> {solicitacao.numFaturaPro}</Typography></TableCell>
                    <TableCell  ><Typography noWrap> {solicitacao.paisOrigem}</Typography></TableCell>
                    <TableCell align="center" ><Typography noWrap> {solicitacao?.status}</Typography></TableCell>
                    <TableCell align="center" ><Typography noWrap> <Date date={solicitacao?.createdAt} /> </Typography></TableCell>
                    <TableCell ><TempoPassado date={solicitacao.updatedAt} /> </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <FerramentaNavegacaoExportacao
            configLista={configLista}
            lista={solicitacoes}
            page={page}
            setPage={setPage}
          />
        </Card>
        :
        <ListaVazia />
        :
        <Loading text={'A carregar solicitações'} />
      }
    </>

  )
}

export default ListaSolicitacoesImportacao 
